<template>
    <div class="Rank">
        <mNav :msg="msg" :IsHome="true"></mNav>
        <div class="ranktitle">{{$t('message.Resut.Medal')}}</div>
        <div class="select_box">
            <el-select v-model="value" :placeholder="$t('message.SearchCond.CourtTips')" @change="changeVal">
                <el-option
                v-for="item in RankArr"
                :key="item.EventID"
                :label="item.text"
                :value="item.EventID">
                </el-option>
            </el-select>
        </div>

        <div class="list_box">
            <van-collapse v-model="activeNames" >
                <van-collapse-item :name="index" v-for="(item,index) in list" :key="index" :disabled="item.PlayerType !=3 ">
                    <template #title>
                        <div>
                            <div class="lis" v-if="item.Rank == 1"><i class="iconfont icon-jiangpai-guanjun-F ics" :style="{'color':'rgb(195,168,0)'}"></i>
                                <span>{{ item.RegisterName }}</span>
                            </div>
                            <div class="lis" v-if="item.Rank == 2"><i class="iconfont icon-jiangpai-yajun-F ics" :style="{'color':'rgb(169,168,168)'}"></i>
                                <span>{{ item.RegisterName }}</span>
                            </div>
                            <div class="lis" v-if="item.Rank == 3"><i class="iconfont icon-jiangpai-jijun-F ics" :style="{'color':'rgb(194,141,23)'}"></i>
                                <span>{{ item.RegisterName }}</span>
                            </div>
                            <div class="lis" v-if="item.Rank != 1 && item.Rank != 2 && item.Rank != 3">
                                <span class="yuan">{{ item.Rank }}</span><span>{{ item.RegisterName }}</span>
                            </div>
                        </div>
                    </template>
                    
                    <template>
                        <div v-if="item.RegisterList">
                            <ul>
                                <li class="lis" :style="{'text-indent': '1rem'}" v-for="(i,inx) in item.RegisterList" :key="inx">{{i.Name}}</li>
                            </ul>
                        </div>
                    </template>
                    
                    <template  #right-icon >
                        <div class="icons"><i v-if="item.RegisterList" class="van-icon van-icon-arrow van-cell__right-icon"></i></div>
                    </template>
                </van-collapse-item>
                
            </van-collapse>



            <!-- <ul>
                <li class="lis">
                    <i class="iconfont icon-jiangpai-guanjun-F ics" :style="{'color':'rgb(195,168,0)'}"></i>
                    张三
                </li>
                <li class="lis">
                    <i class="iconfont icon-jiangpai-yajun-F ics" :style="{'color':'rgb(169,168,168)'}"></i>
                    李四
                </li>
                <li class="lis">
                    <i class="iconfont icon-jiangpai-jijun-F ics" :style="{'color':'rgb(194,141,23)'}"></i>
                    王五
                </li>
                <li class="lis">
                    <i class="iconfont icon-jiangpai-jijun-F ics" :style="{'color':'rgb(194,141,23)'}"></i>
                    狗六
                </li>
            </ul> -->
        </div>
        <div class="annto">
            <div><i class="iconfont icon-jiangpai-guanjun-F ics" :style="{'color':'rgb(195,168,0)'}"></i>{{$t('message.Resut.Gold')}}</div>
            <div><i class="iconfont icon-jiangpai-yajun-F ics" :style="{'color':'rgb(169,168,168)'}"></i>{{$t('message.Resut.Silver')}}</div>
            <div><i class="iconfont icon-jiangpai-jijun-F ics" :style="{'color':'rgb(194,141,23)'}"></i>{{$t('message.Resut.Bronze')}}</div>
        </div>
    </div>
</template>

<script>
import mNav from "@/components/mNav.vue";
import http from '@/assets/js/http.js';
import RankList from '@/assets/common/RankList.json';
import {Loading} from 'element-ui';
export default {
    name: "Rank",
    components: {
        mNav,
    },
    data() {
        return {
            msg: sessionStorage.SportName,
            options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            value: '',
            Rank: [],
            activeNames:[],
            RankArr: [],
            list: [],
            loadingInstance: {},
        }
    },
    mounted() {
        // console.log(Rank)
        this.loadingInstance = Loading.service({
            lock: true,
            text: '正在加载,请稍后...',
        });
        http.GetFile('/Sports/BDM/'+sessionStorage.SportCode+'/RankList.json?v='+Math.random()).then(res=>{//获取赛事列表地址
            this.loadingInstance.close();  // 关闭加载遮罩层
            console.log(res)
            this.Rank = res;
            this.haspolymerization();//数组聚合,重新整合json数据
        })
    },
    methods: {
        changeVal(value){
            // console.log(value)
            let arr = [];
            this.RankArr.forEach((el,index) => {
                if(value === el.EventID){
                    return arr = el.list;
                }
            });
            // console.log(arr);
            this.list = arr;
            this.activeNames = [];
        },
        haspolymerization(){//数组聚合,重新整合json数据
            let echararr = [];
            let data = this.Rank.JsonData;
            // console.log(data)
            /**
             * 将json数据按照日期先整合，重新生成新数组进行页面循环
            */
            data.forEach((el,index) => {
                // console.log(el)
                let arrindex = echararr.findIndex((item,index,arr)=>{
                    return item.text === el.EventName;
                })
                if(arrindex==-1){
                    echararr.push({
                        'text': el.EventName,
                        'EventID': el.EventID,
                        'ID': el.ID,
                        'list': [el],
                    })
                }else{
                    echararr[arrindex]['list'].push(el)
                }
            });
            
            // echararr.sort((a,b)=>{
            //     return new Date(a.date) - new Date(b.date);
            // })
            // echararr.sort()
            console.log(echararr);
            this.RankArr = echararr;
            this.value = echararr[0].EventID;
            this.list = echararr[0].list;
        },
    },
}
</script>

<style lang="scss" scoped>
    ::v-deep .van-collapse-item__title--disabled, .van-collapse-item__title--disabled .van-cell__right-icon{
        color: #333;
    }
    $bgColor: #3277BC;
    .yuan{
        display: inline-block;
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        border: 1px solid $bgColor;
        text-align: center;
        line-height: 0.4rem;
        font-size: 0.24rem;
        text-indent: 0;
    }
    .Rank{
        font-size: 0.2rem;
    }
    .ranktitle{
        padding: 0.3rem;
        font-weight: bold;
        font-size: 0.5rem;
        color: $bgColor;
    }
    .select_box{
        padding: 0.2rem;
    }
    .list_box{
        padding: 0.2rem;
        min-height: 8rem;
    }
    .lis{
        padding: 0.2rem 0;
        // background: white;
        // border-bottom: 1px solid $bgColor;
        font-size: 0.3rem;
        // text-align: center;
        text-indent: 0.2rem;
        // line-height: 0.8rem;
        color: #333;
        .ics{
            font-size: 0.6rem;
            vertical-align: middle;
        }
        span{
            margin-left: 0.1rem;
        }
    }
    .annto{
        padding: 0.2rem;
        display: flex;
        font-size: 0.3rem;
        justify-content: space-around;
        .ics{
            font-size: 0.4rem;
            vertical-align: middle;
        }
        
    }
    
</style>